/* eslint-disable */
<template>
    <basic-container>
      <div
        class="path-container"
        style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
      >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>大白数智家医健康管理医嘱单</el-breadcrumb-item>
      </el-breadcrumb>
      </div>

      <el-button-group style="margin-bottom: 10px">
        <el-button
          class="healthButton"
          style="background-color: #ebedf0"
          @click="click(0)"
          >长期医嘱单
        </el-button>
        <el-button
          class="healthButton"
          style="background-color: #ebedf0"
          @click="click(1)"
          >临时医嘱单
        </el-button>

      </el-button-group>

      <div style="position: relative">
        <!-- <div class="d1"></div> -->

        <div id="pdf-content" class="prescription-container">
          <h1>{{ info.channel }}大白数智家医健康管理长期医嘱单</h1>

          <table class="info-table" style="text-align: center">
            <tr>
              <td style="width: 25mm">姓名</td>
              <td style="width: 30mm">
                <input style="width: 35mm" v-model="info.name" />
              </td>
              <td style="width: 25mm">健康档案号</td>
              <td style="width: 35mm">
                <input style="width: 15mm" v-model="info.sex" />
              </td>

            </tr>
            <tr>
                <td style="width: 25mm">下达日期</td>
              <td style="width: 35mm">
                <el-date-picker
                    v-model="doTime"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
              </td>
              <td style="width: 20mm">家庭护理</td>
              <td>
                <input style="width: 25mm" v-model="info.mobile" />
              </td>
            </tr>
          </table>

          <div class="model" style="">
            <h2>生命体征监测</h2>
            <table class="data-table" style="">
              <tr style="text-align: center">
                <td style="width:30mm">内容</td>
                <td style="width:50mm">用法 (剂量+途径)</td>
                <td style="width:50mm">执行频次(具体时间)</td>
                <td>确认(√)</td>
                <td style="width:10mm">执行人签名</td>
              </tr>
              <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr style="text-align: center">
                <td>血压、心率测量</td>
                <td>
                    <input style="width: 25mm" v-model="lifeArr.xueya" />
                </td>
                <td>每日2次(早7:00/ 晚19:00)</td>
                <td>
                    <span @click="ydfxdj(1)">
                    {{ formData.ydfxdj1 == 1 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="lifeArr.lifePer1" /></td>
              </tr>
              <tr style="text-align: center">
                <td>血糖检测</td>
                <td><input style="width: 25mm" v-model="lifeArr.xueT" /></td>
                <td>每日2次(空腹 / 晚餐后2小时)</td>
                <td>
                    <span @click="ydfxdj(2)">
                    {{ formData.ydfxdj2 == 2 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="lifeArr.lifePer2" /></td>
              </tr>

              <tr style="text-align: center">
                <td>体重及体成分测量</td>
                <td><input style="width: 25mm" v-model="lifeArr.Weight" /></td>
                <td>每日1次(晨起后)</td>
                <td>
                    <span @click="ydfxdj(3)">
                    {{ formData.ydfxdj3 == 3 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="lifeArr.lifePer3" /></td>
              </tr>

            </table>
          </div>

          <div class="model" style="">
            <h2>非药物治疗</h2>
            <table class="data-table" style="">
              <tr style="text-align: center">
                <td style="width:30mm">内容</td>
                <td style="width:50mm">用法 (剂量+途径)</td>
                <td style="width:50mm">执行频次(具体时间)</td>
                <td>确认(√)</td>
                <td style="width:10mm">执行人签名</td>
              </tr>
              <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr style="text-align: center">
                <td>饮食计划</td>
                <td>
                    <input style="width: 25mm" v-model="nonDrug.food" />
                </td>
                <td>每日3次(早/中/晚餐)</td>
                <td>
                    <span  @click="ydfxdj(4)">
                    {{ formData.ydfxdj4 == 4 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="nonDrug.person1" /></td>
              </tr>
              <tr style="text-align: center">
                <td>有氧运动</td>
                <td><input style="width: 25mm" v-model="nonDrug.sport" /></td>
                <td>每周5次(每次30-45分钟)</td>
                <td>
                    <span @click="ydfxdj(5)">
                    {{ formData.ydfxdj5 == 5 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="nonDrug.person2" /></td>
              </tr>

              <tr style="text-align: center">
                <td>力量训练</td>
                <td><input style="width: 25mm" v-model="nonDrug.pour" /></td>
                <td>每周2次(每次20-30分钟)</td>
                <td>
                    <span @click="ydfxdj(6)">
                    {{ formData.ydfxdj6 == 6 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="nonDrug.person3" /></td>
              </tr>
              <tr style="text-align: center">
                <td>睡眠管理</td>
                <td><input style="width: 25mm" v-model="nonDrug.sleep" /></td>
                <td>每日1次(23:00前)</td>
                <td>
                    <span @click="ydfxdj(7)">
                    {{ formData.ydfxdj7 == 7 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="nonDrug.person4" /></td>
              </tr>

            </table>
          </div>

          <div class="model" style="">
            <h2>药物治疗</h2>
            <table class="data-table" style="">
              <tr style="text-align: center">
                <td  style="width:30mm">内容</td>
                <td style="width:50mm">用法 (剂量+途径)</td>
                <td style="width:50mm">执行频次(具体时间)</td>
                <td>确认(√)</td>
                <td style="width:10mm">执行人签名</td>
              </tr>
              <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr style="text-align: center">
                <td>药物名称</td>
                <td>
                    <input style="width: 25mm;border-bottom:1px solid #222" v-model="drug.name" />mg(口服)
                </td>
                <td>每日3次(早/中/晚餐)</td>
                <td>
                    <span @click="ydfxdj(8)">
                    {{ formData.ydfxdj8 == 8 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="drug.person1" /></td>
              </tr>
              <tr style="text-align: center">
                <td>药物名称</td>
                <td> <input style="width: 20mm;border-bottom:1px solid #222" v-model="drug.name2" />mg(皮下注射)</td>
                <td>每周5次(每次30-45分钟)</td>
                <td>
                    <span @click="ydfxdj(9)">
                    {{ formData.ydfxdj9 == 9 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="drug.person2" /></td>
              </tr>

            </table>
          </div>

          <div class="model" style="">
            <h2>健康管理</h2>
            <table class="data-table" style="">
              <tr style="text-align: center">
                <td style="width:30mm">内容</td>
                <td style="width:50mm">用法 (剂量+途径)</td>
                <td style="width:50mm">执行频次(具体时间)</td>
                <td>确认(√)</td>
                <td style="width:10mm">执行人签名</td>
              </tr>
              <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr style="text-align: center">
                <td>健康数据上报</td>
                <td>
                    <input style="width: 25mm" v-model="health.report" />
                </td>
                <td>每日1次(每晚21:00前)</td>
                <td>
                    <span @click="ydfxdj(10)">
                    {{ formData.ydfxdj10 == 10 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="health.person1" /></td>
              </tr>
              <tr style="text-align: center">
                <td>健康知识学习</td>
                <td><input style="width: 25mm" v-model="health.study" /></td>
                <td>每周2次</td>
                <td>
                    <span @click="ydfxdj(11)">
                    {{ formData.ydfxdj11 == 11 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="health.person2" /></td>
              </tr>

              <tr style="text-align: center">
                <td>线上随访</td>
                <td><input style="width: 25mm" v-model="health.online" /></td>
                <td>每2周1次(预约时间)</td>
                <td>
                    <span @click="ydfxdj(12)">
                    {{ formData.ydfxdj12 == 12 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="health.person3" /></td>
              </tr>

            </table>
          </div>

          <div class="model" style="">
            <h2>其他</h2>
            <table class="data-table" style="">
                <tr style="text-align: center">
                <td style="width:30mm">内容</td>
                <td style="width:50mm">用法 (剂量+途径)</td>
                <td style="width:50mm">执行频次(具体时间)</td>
                <td>确认(√)</td>
                <td style="width:10mm">执行人签名</td>
              </tr>
              <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr style="text-align: center">
                <td><input style="width: 25mm" v-model="other.book" /></td>
                <td>
                    <input style="width: 25mm" v-model="other.thing" />
                </td>
                <td><input style="width: 25mm" v-model="other.time" /></td>
                <td>
                    <span @click="ydfxdj(13)">
                    {{ formData.ydfxdj13 == 13 ? "☑" : "☐" }} </span
                  >
                </td>
                <td><input style="width: 25mm" v-model="other.person" /></td>
              </tr>

            </table>
          </div>

          <!-- 签名 -->
          <div class="signature">
            <!-- <p>运动处方师: {{ formData.doctor }}</p> -->
            <div>总确认： 本人已清晰理解以上所有长期医嘱内容，并承诺遵照执行。</div>
            <div class="date">
                <div>执行人签名：<input style="width: 20mm;border-bottom:1px solid #222" v-model="info.userName" /></div>
                <div>日期：
                    <input style="width: 10mm;border-bottom:1px solid #222" v-model="info.year" />年
                    <input style="width: 10mm;border-bottom:1px solid #222" v-model="info.mouth" />月
                    <input style="width: 10mm;border-bottom:1px solid #222" v-model="info.day" />日
                </div>
            </div>
          </div>

        </div>
      </div>

      <div class="pdf-options">
        <el-form label-width="120px">
          <el-form-item label="文件名称">
            <el-input
              v-model="pdfOptions.filename"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="页面方向">
            <el-radio-group v-model="pdfOptions.jsPDF.orientation">
              <el-radio label="portrait">纵向</el-radio>
              <!-- <el-radio label="landscape">横向</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="页面尺寸">
            <el-select
              v-model="pdfOptions.jsPDF.format"
              placeholder="请选择页面尺寸"
            >
              <el-option label="A4 (210×297mm)" value="a4"></el-option>
              <!-- <el-option label="A5 (148×210mm)" value="a5"></el-option>
                <el-option label="Letter (216×279mm)" value="letter"></el-option>
                <el-option label="自定义" value="custom"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item
            label="边距(mm)"
            v-if="pdfOptions.jsPDF.format === 'custom'"
          >
            <el-input-number
              v-model="pdfOptions.margin"
              :min="0"
              :max="50"
            ></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="float: right">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="generatePDF">生成PDF</el-button>
        </span>
      </div>
      <!-- <el-button type="primary" @click="dialogVisible = true">生成PDF</el-button>
      <el-dialog title="生成PDF选项" :visible.sync="dialogVisible" width="340mm" class="my-dialog-class" :top="'1%'">
      </el-dialog> -->
      <!-- <div class="pdf-container">
      </div> -->
    </basic-container>
  </template>

  <script>
  // import { getMotion, getBodyDate } from "@/api/health/manage";
  import { mapGetters } from "vuex";
  import html2pdf from "html2pdf.js";

  export default {
    data() {
      return {
        wxUserId: this.$route.query.wxUserId,
        info: {},
        form: {},
        lifeArr: {},
        nonDrug: {},
        drug: {},
        health: {},
        other: {},
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        data: [],
        showDialog: false, // 控制弹框显示
        formData: {
            ydfxdj1: 0,

          followUpDate: new Date().toLocaleDateString(),
        },
        dialogVisible: false,
        pdfOptions: {
          margin: 10,
          filename: "长期医嘱.pdf",
          image: {
            type: "jpeg",
            quality: 0.98,
          },
          html2canvas: {
            scale: 2,
            useCORS: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
          },
        },
        doTime: ''
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.permission.health_userjk_add,
          viewBtn: this.permission.health_userjk_view,
          delBtn: this.permission.health_userjk_delete,
          editBtn: this.permission.health_userjk_edit,
        };
      },
      ids() {
        const ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(",");
      },
    },
    created() {
      this.onLoad();
    },
    methods: {
      onLoad() {
        // const wxUserId = this.$route.query.wxUserId;
        // this.formData.followUpDate = new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString();
        // console.log("123", new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString())

      },

      ydfxdj(index) {
        console.log(index);
        const that = this;
        switch (index) {
            case 1:
                if (index === that.formData.ydfxdj1) {
                    that.formData.ydfxdj1 = 0;
                } else {
                    console.log(that.formData.ydfxdj1);
                    that.formData.ydfxdj1 = index;
                }
                break;
            case 2:
            if (index === that.formData.ydfxdj2) {
                that.formData.ydfxdj2 = 0;
            } else {
                console.log(that.formData.ydfxdj2);
                that.formData.ydfxdj2 = index;
            }
            break;
            case 3:
            if (index === that.formData.ydfxdj3) {
                that.formData.ydfxdj3 = 0;
            } else {
                console.log(that.formData.ydfxdj3);
                that.formData.ydfxdj3 = index;
            }
            break;
            case 4:
            if (index === that.formData.ydfxdj4) {
                that.formData.ydfxdj4 = 0;
            } else {
                console.log(that.formData.ydfxdj4);
                that.formData.ydfxdj4 = index;
            }
            break;
            case 5:
            if (index === that.formData.ydfxdj5) {
                that.formData.ydfxdj5 = 0;
            } else {
                console.log(that.formData.ydfxdj5);
                that.formData.ydfxdj5 = index;
            }
            break;
            case 6:
            if (index === that.formData.ydfxdj6) {
                that.formData.ydfxdj6 = 0;
            } else {
                console.log(that.formData.ydfxdj6);
                that.formData.ydfxdj6 = index;
            }
            break;
            case 7:
            if (index === that.formData.ydfxdj7) {
                that.formData.ydfxdj7 = 0;
            } else {
                console.log(that.formData.ydfxdj7);
                that.formData.ydfxdj7 = index;
            }
            break;
            case 8:
            if (index === that.formData.ydfxdj8) {
                that.formData.ydfxdj8 = 0;
            } else {
                console.log(that.formData.ydfxdj8);
                that.formData.ydfxdj8 = index;
            }
            break;
            case 9:
            if (index === that.formData.ydfxdj9) {
                that.formData.ydfxdj9 = 0;
            } else {
                console.log(that.formData.ydfxdj9);
                that.formData.ydfxdj9 = index;
            }
            break;
            case 10:
            if (index === that.formData.ydfxdj10) {
                that.formData.ydfxdj10 = 0;
            } else {
                console.log(that.formData.ydfxdj10);
                that.formData.ydfxdj10 = index;
            }
            break;
            case 11:
            if (index === that.formData.ydfxdj11) {
                that.formData.ydfxdj11 = 0;
            } else {
                console.log(that.formData.ydfxdj11);
                that.formData.ydfxdj11 = index;
            }
            break;
            case 12:
            if (index === that.formData.ydfxdj12) {
                that.formData.ydfxdj12 = 0;
            } else {
                console.log(that.formData.ydfxdj12);
                that.formData.ydfxdj12 = index;
            }
            break;
            case 13:
            if (index === that.formData.ydfxdj13) {
                that.formData.ydfxdj13 = 0;
            } else {
                console.log(that.formData.ydfxdj13);
                that.formData.ydfxdj13 = index;
            }
            break;
        }
      },

      generatePDF() {
        this.showDialog = false; // 关闭弹框
        const element = document.getElementById("pdf-content");

        const opt = {
          margin: 0,
          filename: this.pdfOptions.filename,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        };

        html2pdf().from(element).set(opt).save();
      },

      click(index) {
        let path = "";
        switch (index) {
          case 0:
            path = "/healthmanagement/doctorOrder";
            break;
          case 1:
            path = "/healthmanagement/doctorInterimOrder";
            break;
        }
        const parameter = {
          wxUserId: this.wxUserId,
        };
        this.$router.push({
          path: path,
          query: parameter,
        });
      },

      back() {
        // this.$router.go(-1);
        this.$router.push({
          path: "/agent/weightLoss",
        });
      },
    },
  };
  </script>

  <style scoped>
  /* 重置所有继承属性 */
  .style-isolation {
    all: initial;
  }

  /* 重置内部所有元素 */
  .style-isolation * {
    all: unset;
  }

  .tr {
    vertical-align: middle;
    display: table-row;
    vertical-align: inherit;
    unicode-bidi: isolate;
    border-color: inherit;
  }

  .my-dialog-class {
    display: flex;
    align-items: flex-start;
  }

  .prescription-container {
    /* font-family: "SimSun", "宋体", serif; */
    width: 210mm;
    height: 296mm;
    padding: 0mm 10mm;
    box-sizing: border-box;
    float: left;
    font-family: Segoe UI, PingFang SC, Microsoft YaHei, sans-serif;
    border: 1px solid #000;
    line-height: 1.4;

    /* 防止PDF白条的关键属性 */
    border-collapse: separate !important;
    border-spacing: 0 !important;
    background: transparent !important;
    overflow: visible !important;
    position: relative !important;
    z-index: 1 !important;
  }

  input {
    border: 0px;
    line-height: 1.5;
    text-align: center;
  }

  .pdf-options {
    padding-left: 2%;
    float: left;
    width: 100mm;
  }

  h1 {
    text-align: center;
    font-size: 24px;
    /* margin-bottom: 20px; */
    color: #0066cc;
  }

  .info-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0px;
  }

  .info-table td {
    border: 1px solid #000;
    padding: 1mm;
    font-size: 14px;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0px;
  }

  .data-table td {
    border: 1px solid #000;
    padding: 1mm;
    font-size: 13px;
  }

  .model {
    margin-bottom: 0px;
  }

  h2 {
    font-size: 16px;
    color: #0066cc;
    /* border-bottom: 1px solid #e0e0e0; */
    box-sizing: border-box;
  }

  h3 {
    font-size: 18px;
    margin: 10px 0;
    border-bottom: 1px solid #000;
    padding-bottom: 5px;
  }

  ul,
  ol {
    margin-left: 20px;
  }

  .signature{
     margin-top:10px;
  }

  .signature div {
    width:100%;
    height:50px;
    line-height:50px;
    font-size: 14px;;
    /* text-align: right; */
  }
  .signature .date {
    display:flex;
    flex-direction: row;
    justify-content:space-between ;
  }

  p {
    margin-bottom: 0px;
    /* line-height: 1.7; */
  }

  template {
    all: initial;
  }

  .healthButton {
    /* background-color: #ebedf0; */
    color: black;
    border: 1px solid #c1c3c5;
    border-bottom: none;
    font-size: 15px;
    border-radius: 0px;
  }
  .custom-datepicker .el-input__inner {
  border: none;
  box-shadow: none;
  background-color: transparent;
}
  </style>
